import Channel from 'builders/builderChannel/configMode/Page';

export default function index() {
    return (
        <Channel />
    );
}
